export type IconName = 'arrowUpRight' | 'arrowRight' | 'arrowLeft' | 'arrowDown' | 'chevronDown' | 'check' | 'menu' | 'close' | 'mail' | 'globe' | 'flask' | 'x' | 'linkedin';

const STROKE_PATHS: Partial<Record<IconName, string[]>> = {
    arrowUpRight: ['M7 17L17 7', 'M8 7h9v9'],
    arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
    arrowLeft: ['M19 12H5', 'M11 6l-6 6 6 6'],
    arrowDown: ['M12 5v14', 'M6 13l6 6 6-6'],
    chevronDown: ['M6 9l6 6 6-6'],
    check: ['M5 12.5l4.5 4.5L19 7.5'],
    menu: ['M4 9h16', 'M4 15h16'],
    close: ['M6 6l12 12', 'M18 6L6 18'],
    mail: ['M4 6.5h16v11H4z', 'M4.5 7l7.5 6 7.5-6'],
    globe: ['M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18z', 'M3.5 12h17', 'M12 3c2.5 2.6 3.6 5.6 3.6 9s-1.1 6.4-3.6 9c-2.5-2.6-3.6-5.6-3.6-9S9.5 5.6 12 3z'],
    flask: ['M9 3h6', 'M10 3v6.5L4.9 18.2A1.2 1.2 0 0 0 6 20h12a1.2 1.2 0 0 0 1.1-1.8L14 9.5V3', 'M7.2 15h9.6']
};

const FILL_PATHS: Partial<Record<IconName, string>> = {
    x: 'M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78zm-1.08 16.18h1.7L7.4 4.73H5.58z',
    linkedin: 'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.75h4v11H3zm6.5 0h3.83v1.5h.06c.53-1 1.84-2.06 3.79-2.06 4.05 0 4.8 2.67 4.8 6.14v5.42h-4v-4.8c0-1.15-.02-2.62-1.6-2.62-1.6 0-1.84 1.25-1.84 2.54v4.88h-4z'
};

interface IconProps {
    name: IconName;
    className?: string;
}

export default function Icon({ name, className }: IconProps) {
    const fillPath = FILL_PATHS[name];

    return (
        <svg className={className} viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
            {fillPath ? (
                <path d={fillPath} fill="currentColor" />
            ) : (
                <g fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                    {STROKE_PATHS[name]?.map((path) => <path key={path} d={path} />)}
                </g>
            )}
        </svg>
    );
}
